import type { AlertProps } from "@chakra-ui/react";
import { Alert, AlertDescription, AlertIcon, AlertTitle } from "@chakra-ui/react";

export const PageAlert = ({ title, children, status, ...rest }: AlertProps) => {
    return (
        <Alert mt={12} mx={'auto'} status={status} {...rest} w={'md'} flexDir={'column'}>
            <AlertIcon mt={8} mx={'auto'} boxSize={12} />
            <AlertTitle my={8} fontSize={'xl'} fontWeight={'normal'}>{title}</AlertTitle>
            <AlertDescription mb={8}>{children}</AlertDescription>
        </Alert>
    )
}